import React from 'react';
import { RecordingAsset } from 'types';

import { CardSkeleton } from '../../CardSkeleton/CardSkeleton';
import { CardContainerProps } from '../../types';
import RecordingCard from '../RecordingCard/RecordingCard';

function RecordingCardContainer({ data, itemWidth, imageHeight }: CardContainerProps<RecordingAsset>) {
  if (!data?.id) {
    return <CardSkeleton height={imageHeight} width={itemWidth} />;
  }

  return (
    <RecordingCard bookmark={data.bookmark} imageHeight={imageHeight} imageWidth={itemWidth} recording={data.asset} />
  );
}

export default React.memo(RecordingCardContainer);
